import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "modal", "input", "error"]

  openModal() {
    this.modalTarget.classList.add("is-active")
    this.inputTarget.value = ""
    this.errorTarget.classList.add("is-hidden")
    this.inputTarget.focus()
  }

  closeModal() {
    this.modalTarget.classList.remove("is-active")
  }

  save(event) {
    const name = this.inputTarget.value.trim()
    const endpoint = event.currentTarget.dataset.endpoint
    const paramKey = event.currentTarget.dataset.paramKey || "item_partner"
    const button = event.currentTarget

    const t = (key, defaultText) => {
      if (typeof I18n !== 'undefined' && I18n.t) {
        return I18n.t(key, { default: defaultText })
      }
      return defaultText
    }

    if (!name) {
      this.showError(t("community.settings.item_classifications.form.error_blank", "O nome não pode estar em branco"))
      return
    }

    const originalHTML = button.innerHTML
    button.disabled = true
    button.innerHTML = t("community.settings.item_classifications.form.saving", "Salvando...")

    const csrfMeta = document.querySelector('meta[name="csrf-token"]')
    let csrfToken = ""
    if (csrfMeta) {
      csrfToken = csrfMeta.getAttribute('content')
    } else if (typeof Rails !== 'undefined' && Rails.csrfToken) {
      csrfToken = Rails.csrfToken()
    }

    const bodyData = {}
    bodyData[paramKey] = { name: name }

    fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify(bodyData)
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => { throw err })
      }
      return response.json()
    })
    .then(data => {
      // Cria a nova opção, insere e seleciona automaticamente
      const option = document.createElement("option")
      option.value = data.id
      option.text = data.name
      option.selected = true
      
      this.selectTarget.add(option)
      this.closeModal()

      if (typeof iziToast !== 'undefined') {
        iziToast.success({
          title: t("community.settings.item_classifications.form.success_title", "Sucesso"),
          message: t("community.settings.item_classifications.form.success_toast", "Registro criado com sucesso!"),
          class: "notification is-light"
        });
      }
    })
    .catch(error => {
      const defaultErrorMsg = t("community.settings.item_classifications.form.error_saving", "Erro ao salvar o registro")
      const msg = error.errors ? error.errors.join(", ") : defaultErrorMsg
      this.showError(msg)
    })
    .finally(() => {
      button.disabled = false
      button.innerHTML = originalHTML
    })
  }

  showError(message) {
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("is-hidden")
  }
}
